import { render, staticRenderFns } from "./tiemposEvaluacionReconocimiento.vue?vue&type=template&id=9d133e7c&scoped=true"
import script from "./tiemposEvaluacionReconocimiento.vue?vue&type=script&lang=js"
export * from "./tiemposEvaluacionReconocimiento.vue?vue&type=script&lang=js"
import style0 from "./tiemposEvaluacionReconocimiento.vue?vue&type=style&index=0&id=9d133e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d133e7c",
  null
  
)

export default component.exports